import { HStack } from '@rbilabs/universal-components';

export const Nutrient = HStack.withConfig({
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: 1,
  focusable: true,
});
